<template>
<div class="stamp" :class="{ five: stampCard.stamps.length === 5 }">
  <div class="wrapper">
    <img :src="imagePath" />
    <div class="date" :class="{
          namiki: stampCard.stamps[idx].layout === '2',
          kiraku: stampCard.stamps[idx].layout === '1'
        }">
      {{ stampedAt(stampCard.stamps, idx) }}
    </div>
    <div class="number" :class="{ last: isLast, five: stampCard.stamps.length === 5 }">
      {{ numberAt(stampCard.stamps, idx) }}
    </div>
  </div>
</div>
</template>

<script>
export default {
  name: 'StampHistoryCardBodyStamp',
  props: ['stampCard', 'idx'],
  data: function () {
    return {}
  },
  created() {},
  computed: {
    isLast: function () {
      return this.stampCard.stamps.length - 1 === Number(this.idx)
    },
    imagePath: function () {
      let path = this.stampCard.stamps[this.idx].image_url
      if (!path) {
        if (this.isLast) {
          path = require('@/assets/img/stampHistory/STAMP_STAR_BLANK.png')
        } else {
          path = require('@/assets/img/stampHistory/STAMP_BLANK.png')
        }
      }
      return path
    }
  },
  methods: {
    imageUrl: (stamps, idx) => stamps[idx].image_url,
    stampedAt: (stamps, idx) => stamps[idx].stamped_at,
    numberAt: function (stamps, idx) {
      if (stamps[idx].stamped_at) {
        return ''
      } else {
        return this.stampCard.stamp_start_num + Number(idx)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.stamp {
  display: inline-block;
  margin: 0 5px;
  width: 20%;

  &.five {
    width: 25%;
  }

  vertical-align: middle;

  .wrapper {
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
  }

  img {
    width: 100%;
    height: 100%;
  }

  .date {
    position: absolute;
    top: 60%;
    font-size: 2.4vw;
    color: #5d2410;

    &.kiraku {
      color: #cf0918;
    }

    &.namiki {
      color: #d5c1a7;
      top: 50%;
    }
  }

  .number {
    position: absolute;
    color: #cccccc;
    font-size: 4.4vw;
    font-weight: bold;

    &.last {
      top: 30%;
      font-size: 3.3vw;
      color: white;
      font-weight: bold;

      &.five {
        top: 33%;
        font-size: 4.3vw;
      }
    }
  }
}
</style>
